/* ASELECION – Produkt/Magazin-Toggle + Magazin-Ticker (alle 20 s) + ?legal= + Reveal */
(function(){
var EVERY=20000;
var LOC=window.ASEL_LOC||{},ROOT=LOC.root||'/',PRE=ROOT==='/'?'':ROOT.replace(/\/$/,'');
function ticker(hdr){
 var L=(window.ASEL_MZ||[]).filter(function(a){return a&&a.t});if(!L.length||hdr.querySelector('.mzt'))return;
 for(var i=L.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),x=L[i];L[i]=L[j];L[j]=x}
 var bar=document.createElement('div');bar.className='mzt';
 bar.innerHTML='<a href="'+L[0].u+'"><span class="lb"><i></i>Aus dem Magazin</span><span class="tx"></span><span class="ar">→</span></a><span class="pr"></span>';
 hdr.appendChild(bar);
 var a=bar.querySelector('a'),tx=bar.querySelector('.tx'),pr=bar.querySelector('.pr'),k=0;
 function show(n){var it=L[n%L.length];tx.textContent=it.t;a.href=it.u;a.title=it.t;var p=pr.cloneNode();pr.replaceWith(p);pr=p}
 show(0);
 setInterval(function(){if(document.hidden)return;tx.classList.add('out');setTimeout(function(){k++;show(k);tx.classList.remove('out')},450)},EVERY);
}
function place(seg,el){
 var t=seg.querySelector('.thumb');if(!t||!el)return;
 t.style.width=el.offsetWidth+'px';t.style.transform='translateX('+el.offsetLeft+'px)';
}
function buildSeg(w){
 if(w.querySelector('.seg'))return;
 var old=w.querySelector('.mag');old&&old.remove();
 var isMag=/\/blogs\//.test(location.pathname);
 var seg=document.createElement('nav');
 seg.className='seg';
 seg.setAttribute('aria-label','Produkt oder Magazin anzeigen');
 seg.innerHTML='<span class="thumb"></span>'+
  '<a href="'+PRE+'/"'+(isMag?'':' class="on"')+'>Produkt</a>'+
  '<a href="'+PRE+'/blogs/magazin"'+(isMag?' class="on"':'')+'>Magazin</a>';
 var ref=w.querySelector('.asel-ctl')||w.querySelector('.pill');
 w.insertBefore(seg,ref||null);
 function snap(){if(seg.classList.contains('moving'))return;place(seg,seg.querySelector('a.on'));seg.classList.add('ready')}
 snap();
 if(document.fonts&&document.fonts.ready)document.fonts.ready.then(snap);
 window.addEventListener('resize',snap);
 window.addEventListener('pageshow',function(){seg.classList.remove('anim','moving');var c=seg.querySelector(isMag?'a[href$="/blogs/magazin"]':'a:first-of-type');seg.querySelectorAll('a').forEach(function(x){x.classList.toggle('on',x===c)});snap()});
 seg.addEventListener('click',function(e){
  var a=e.target.closest('a');if(!a||a.classList.contains('on')||e.metaKey||e.ctrlKey||e.shiftKey)return;
  e.preventDefault();
  seg.classList.add('anim','moving');
  seg.querySelectorAll('a').forEach(function(x){x.classList.toggle('on',x===a)});
  place(seg,a);
  window.ASEL_LEAVE&&window.ASEL_LEAVE();
  setTimeout(function(){location.href=a.href},window.matchMedia('(prefers-reduced-motion:reduce)').matches?0:240);
 });
}
function run(){
 var hdr=document.querySelector('.hdr'),w=hdr&&hdr.querySelector('.wrap');
 if(w)buildSeg(w);
 if(!/\/blogs\//.test(location.pathname)&&hdr)ticker(hdr);
 var q=new URLSearchParams(location.search).get('legal');
 if(q){var b=document.querySelector('[data-open="dlg-'+q+'"]');b&&setTimeout(function(){b.click()},300)}
 var els=document.querySelectorAll('.mz .rv');
 if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});els.forEach(function(e){io.observe(e)})}else els.forEach(function(e){e.classList.add('in')});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
